/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.assignments.rpc.UserCapacityLimitsV2Service
 */

export const upsertTotalTicketCapacityLimitsRpc = {
  serviceName: 'com.hubspot.cv.assignments.rpc.UserCapacityLimitsV2Service',
  rpcName: 'upsertTotalTicketCapacityLimits',
  auth: 'app',
  fingerprint: 'h7hhrsVTyZU4KKlJY6wtNti9_tjc97ic',
  na1Only: false,
  isStreaming: false
};
export const upsertTicketCapacityLimitsRpc = {
  serviceName: 'com.hubspot.cv.assignments.rpc.UserCapacityLimitsV2Service',
  rpcName: 'upsertTicketCapacityLimits',
  auth: 'app',
  fingerprint: 'g5JNnUPCqQTGtXi--h7Qbti9_tjc97ic',
  na1Only: false,
  isStreaming: false
};
export const deleteTotalTicketCapacityLimitsRpc = {
  serviceName: 'com.hubspot.cv.assignments.rpc.UserCapacityLimitsV2Service',
  rpcName: 'deleteTotalTicketCapacityLimits',
  auth: 'app',
  fingerprint: 'nVi6_BHURQajarmr_fiTNNi9_tjc97ic',
  na1Only: false,
  isStreaming: false
};
export const deleteTicketCapacityLimitsRpc = {
  serviceName: 'com.hubspot.cv.assignments.rpc.UserCapacityLimitsV2Service',
  rpcName: 'deleteTicketCapacityLimits',
  auth: 'app',
  fingerprint: 'ZPLCF_ZnoiAoNdfIbD7d0di9_tjc97ic',
  na1Only: false,
  isStreaming: false
};
export const getCapacityEligibleTeamsRpc = {
  serviceName: 'com.hubspot.cv.assignments.rpc.UserCapacityLimitsV2Service',
  rpcName: 'getCapacityEligibleTeams',
  auth: 'app',
  fingerprint: 'tEzYSJLpFD2r3FT9Y-k5vNi9_tjc97ic',
  na1Only: false,
  isStreaming: false
};
export const getCurrentUserCapacityDataRpc = {
  serviceName: 'com.hubspot.cv.assignments.rpc.UserCapacityLimitsV2Service',
  rpcName: 'getCurrentUserCapacityData',
  auth: 'app',
  fingerprint: 'GeldOVzy-q4I-swLg3uAi9i9_tjc97ic',
  na1Only: false,
  isStreaming: false
};
export const getUserCapacityDataRpc = {
  serviceName: 'com.hubspot.cv.assignments.rpc.UserCapacityLimitsV2Service',
  rpcName: 'getUserCapacityData',
  auth: 'app',
  fingerprint: 'ybEnlLQAZYgrUZE0ecmHLti9_tjc97ic',
  na1Only: false,
  isStreaming: false
};